import {Dispatch} from "redux";
import {Action} from "../actions/uploadingImagesProgressActions";
import {ActionType} from "../actionTypes";
import {UploadProgressingImagesDto} from "../../dtos";


export const startUploadingImagesProgressPopup = () => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.UPLOAD_IMAGES_PROGRESSBAR_POPUP_START,
            payload: {
                title: ""
            }
        });
    }

}

export const errorUploadingImagesProgressPopup = () => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.UPLOAD_IMAGES_PROGRESSBAR_POPUP_ERROR,
        });
    }

}
export const changeUploadingImagesProgressPopup = (changedData: UploadProgressingImagesDto) => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.UPLOAD_IMAGES_PROGRESSBAR_POPUP_CHANGE,
            payload: changedData
        });
    }

}
export const closeUploadingImagesProgressPopup = () => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.UPLOAD_IMAGES_PROGRESSBAR_POPUP_CLOSE,
        });
    }

}
